module.exports = __webpack_public_path__ + "img/7d732a6.png";